import pythonApiClient from "./pythonBaseApi";

const checkInManualApi = {
  /**
   * Validar archivo Excel de check-in manual
   * @param {File} file - Archivo Excel con columnas: Fecha Check-in, Numero Documento Identidad, Zona, Modulo, Habitacion, Cama
   * @param {number} proyectoId - ID del proyecto
   * @param {boolean} autoCompleteDniLength - Si se debe autocompletar el DNI con ceros
   * @param {boolean} skipDuplicateValidation - Si se permite check-in de trabajadores que ya tienen asignación
   * @returns {Promise} Respuesta de validación
   */
  validateFile: (file, proyectoId, autoCompleteDniLength = false, skipDuplicateValidation = false) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("proyecto_id", proyectoId);
    formData.append("auto_complete_dni_length", autoCompleteDniLength ? "true" : "false");
    formData.append("skip_duplicate_validation", skipDuplicateValidation ? "true" : "false");
    
    return pythonApiClient.post(
      "/procesos/hoteleria/check-in-manual/validate",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },

  /**
   * Procesar check-in manual desde archivo Excel
   * @param {File} file - Archivo Excel con columnas: Fecha Check-in, Numero Documento Identidad, Zona, Modulo, Habitacion, Cama
   * @param {number} proyectoId - ID del proyecto
   * @param {boolean} autoCompleteDniLength - Si se debe autocompletar el DNI con ceros
   * @param {boolean} skipDuplicateValidation - Si se permite check-in de trabajadores que ya tienen asignación
   * @returns {Promise} Resultado del procesamiento
   */
  procesarCheckIns: (file, proyectoId, autoCompleteDniLength = false, skipDuplicateValidation = false) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("proyecto_id", proyectoId);
    formData.append("auto_complete_dni_length", autoCompleteDniLength ? "true" : "false");
    formData.append("skip_duplicate_validation", skipDuplicateValidation ? "true" : "false");
    
    return pythonApiClient.post(
      "/procesos/hoteleria/check-in-manual",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },

  /**
   * Buscar check-in por DNI
   * @param {string} dni - Número de documento de identidad
   * @param {number} proyectoId - ID del proyecto
   * @param {boolean} autoCompleteDniLength - Si se debe autocompletar el DNI con ceros
   * @returns {Promise} Información del check-in
   */
  buscarCheckInPorDni: (dni, proyectoId, autoCompleteDniLength = false) => {
    return pythonApiClient.get(
      `/procesos/hoteleria/check-in-manual/buscar/${dni}`,
      {
        params: {
          proyecto_id: proyectoId,
          auto_complete_dni_length: autoCompleteDniLength,
        },
      }
    );
  },

  /**
   * Realizar check-in individual
   * @param {string} dni - Número de documento de identidad
   * @param {string} fechaCheckIn - Fecha del check-in (YYYY-MM-DD o DD/MM/YYYY)
   * @param {string} zonaNombre - Nombre de la zona
   * @param {string} moduloNombre - Nombre del módulo
   * @param {string} habitacionNumero - Número de la habitación
   * @param {string} camaNumero - Número de la cama
   * @param {number} proyectoId - ID del proyecto
   * @param {boolean} autoCompleteDniLength - Si se debe autocompletar el DNI con ceros
   * @returns {Promise} Resultado del check-in
   */
  realizarCheckInIndividual: (
    dni,
    fechaCheckIn,
    zonaNombre,
    moduloNombre,
    habitacionNumero,
    camaNumero,
    proyectoId,
    autoCompleteDniLength = false
  ) => {
    const formData = new FormData();
    formData.append("dni", dni);
    formData.append("fecha_checkin", fechaCheckIn);
    formData.append("zona", zonaNombre);
    formData.append("modulo", moduloNombre);
    formData.append("habitacion", habitacionNumero);
    formData.append("cama", camaNumero);
    formData.append("proyecto_id", proyectoId);
    formData.append("auto_complete_dni_length", autoCompleteDniLength ? "true" : "false");
    
    return pythonApiClient.post(
      "/procesos/hoteleria/check-in-manual/individual",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
};

export default checkInManualApi;
